import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popular-slider',
  templateUrl: './popular-slider.component.html',
  styleUrls: ['./popular-slider.component.scss']
})
export class PopularSliderComponent implements OnInit {
  cardData = [
    {
      image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602251635/C-Lmap_skwy79.png',
      title: 'CEILING LAMPS'
    },
    {
      image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602251637/Chandelier_p5feli.png',
      title: 'CHANDELIERS'
    }
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
